function filterClick() {
  var filterBody = document.querySelector('.usf-facets.usf-sr-filters');
  var filterBg = document.querySelector('.filter-overlay-background');
  filterBody.classList.add("open-filter");
  filterBg.classList.add("open-filter");
}
function closeFilter() {
  var filterBody = document.querySelector('.usf-facets.usf-sr-filters');
  var filterBg = document.querySelector('.filter-overlay-background');
  filterBody.classList.remove("open-filter");
  filterBg.classList.remove("open-filter");
}
function showProduct() {
  var filterBody = document.querySelector('.usf-facets.usf-sr-filters');
  var filterBg = document.querySelector('.filter-overlay-background');
  filterBody.classList.remove("open-filter");
  filterBg.classList.remove("open-filter");
}